import { api } from "./apiClient";

export interface BackupCreateResponse {
  success: boolean;
  filename?: string;
  message: string;
}

export const backupsService = {
  list: () => api.get<string[]>("/backups/"),
  generate: () => api.post<BackupCreateResponse>("/backups/generate", {}),
  generateSql: () => api.post<BackupCreateResponse>("/backups/generate-sql", {}),
  generateSqlFromBackup: (bkuFilename: string) =>
    api.post<BackupCreateResponse>(`/backups/${bkuFilename}/generate-sql`, {}),
  remove: (filename: string) => api.delete<{ ok: boolean; message?: string }>(`/backups/${filename}`),
};
